export var MobileQueryRoutes = {
    EVALUATION_SURVEY: '/degerlendirme-anketi'
};
export var MobileQuerySearchParams = {
    M: { key: 'm', value: '1' }
};
